import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'get'

export default class OspreyMessagesSearch extends BaseAction {
    constructor(dataKey) {
        const id = '89a51268-0891-43a9-821c-6e19e27a145a'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = Object.assign({
            fields: 'id,thumbnail,name,status,goal,channels,audiences,description,template,nextSend,tags,createdOn,schedule,history'
        }, params)

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-search.js